import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, exhaustMap, filter, map, of, tap } from 'rxjs';
import { AuthService as AuthExternalService } from '../../generated/auth/services/auth.service';
import { AuthService } from '../../services/auth.service';
import { NotificationService } from '../../services/notification.service';
import * as authActions from './auth.actions';

@Injectable()
export class AuthEffect {
  private action$ = inject(Actions);
  private authExternalService = inject(AuthExternalService);
  private authService = inject(AuthService);
  private notificationService = inject(NotificationService);

  constructor() {}

  refreshUserInformation = createEffect(() =>
    this.action$.pipe(
      ofType(authActions.refreshUserInformation),
      filter(() => !!this.authService.getTokenValue()),
      exhaustMap(() =>
        this.authExternalService.authAccountGetUserInformationGet().pipe(
          map((response) => authActions.refreshUserInformationSuccess({ payload: response.result })),
          catchError((error) => of(authActions.refreshUserInformationFailure({ error }))),
        ),
      ),
    ),
  );

  expiredAccess = createEffect(
    () =>
      this.action$.pipe(
        ofType(authActions.expiredAccess),
        tap(() => {
          this.notificationService.info('Your session has expired. Please re-enter the portal again.');
          this.authService.removeToken();
          this.authService.clearReturnUrl();
          this.authService.navigateToLogin();
        }),
      ),
    { dispatch: false },
  );
}
